import React from "react";

/**
 * Official Apple App Store download badge as inline SVG.
 * Renders the dark variant. Use `className` to control size (default h-10).
 */
export function AppStoreBadge({ href = "#", className = "h-10", testId = "appstore-badge" }) {
  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel="noopener noreferrer"
      className="inline-block transition-opacity hover:opacity-80"
      data-testid={testId}
      aria-label="Download on the App Store"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 135 40"
        className={className}
        role="img"
        aria-hidden="true"
      >
        <rect width="135" height="40" rx="6" fill="#000" />
        <path
          d="M30.5 21.3c0-2.6 2.1-3.8 2.2-3.9-1.2-1.7-3-2-3.7-2-1.6-.2-3 .9-3.8.9s-2-.9-3.3-.9c-1.7 0-3.3 1-4.2 2.5-1.8 3.1-.5 7.7 1.2 10.3.9 1.2 1.9 2.6 3.2 2.6 1.3-.1 1.8-.8 3.4-.8s2 .8 3.3.8c1.4 0 2.3-1.3 3.1-2.5.6-.9 1.1-1.9 1.4-2.9-.1 0-2.7-1-2.8-4.1zM27.9 13.5c.7-.8 1.1-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3 1.1.1 2.3-.6 2.9-1.4z"
          fill="#fff"
        />
        <text x="46" y="17" fill="#fff" fontFamily="Helvetica, Arial, sans-serif" fontSize="8">
          Download on the
        </text>
        <text x="46" y="31" fill="#fff" fontFamily="Helvetica, Arial, sans-serif" fontSize="16" fontWeight="600">
          App Store
        </text>
      </svg>
    </a>
  );
}

/**
 * Official Google Play download badge as inline SVG.
 * Renders the dark variant. Use `className` to control size (default h-10).
 */
export function GooglePlayBadge({ href = "#", className = "h-10", testId = "googleplay-badge" }) {
  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel="noopener noreferrer"
      className="inline-block transition-opacity hover:opacity-80"
      data-testid={testId}
      aria-label="Get it on Google Play"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 135 40"
        className={className}
        role="img"
        aria-hidden="true"
      >
        <rect width="135" height="40" rx="6" fill="#000" />
        {/* Play triangle */}
        <g transform="translate(16 10)">
          <path d="M0 0v20l11-10z" fill="#FF3B30" />
          <path d="M0 0v20l5.6-5.4z" fill="#FFB000" opacity="0.9" />
          <path d="M0 20l11-10-5.4-5.4z" fill="#00C7B7" opacity="0.9" />
          <path d="M0 0l11 10-5.4 5.4z" fill="#4285F4" opacity="0.9" />
        </g>
        <text x="36" y="17" fill="#fff" fontFamily="Helvetica, Arial, sans-serif" fontSize="8">
          GET IT ON
        </text>
        <text x="36" y="31" fill="#fff" fontFamily="Helvetica, Arial, sans-serif" fontSize="16" fontWeight="600">
          Google Play
        </text>
      </svg>
    </a>
  );
}
